"use client";
import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "../../../Assets/css/benchmarkPage.css";
import Banner from '../../../Assets/images/benchmark-wedding-band-imgs/benchmark-mens-wedding-bands-banner.jpg'
import ammara from '../../../Assets/images/benchmark-wedding-band-imgs/ammara-stone.jpg'
import brook from '../../../Assets/images/benchmark-wedding-band-imgs/brook-branch.jpg'
import benchmark from '../../../Assets/images/benchmark-wedding-band-imgs/benchmark.jpg'
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const BenchmarkPage = () => {
    const history = useHistory();
  return (
    <>
    <div className="banchmark_page_sectoion">
 {/* ===== Banner Section ===== */}
      <section className="benchmark-banner">
        <Container fluid className="p-0">
          <div className="banner-image">
            {/* Add your banner image here */}
            <img
              src={Banner}
              alt="Benchmark Banner"
              className="img-fluid w-100"
               onClick={()=> window.open(" https://www.benchmarkrings.com/wedding-rings", "_blank")}
            />
          </div>
        </Container>
      </section>

      {/* ===== Collection Section ===== */}
      <section className="benchmark-collections py-5">
        <Container className="custom-container" >
          <h1 className="text-center mb-5 fw-bold">
            Men's Benchmark Rings
          </h1>

          {/* ===== Ammara Stone ===== */}
          <Row className="align-items-center">
            <Col md={6}>
             <div className="image-hover-wrapper">
              <img
                src={ammara}
                alt="Ammara Stone"
                className="img-fluid rounded shadow"
                 onClick={()=> window.open("https://www.benchmarkrings.com/collections/ammara-stone" , "_blank")}
              />
             </div>
            </Col>

            <Col md={6} className="text-center text-md-start mt-4 mt-md-0">
              <h4 className="fw-bold">Ammara Stone Collection</h4>
              <p>
                The Exclusive Ammara Stone Line Of Wedding Rings Fuses Classic
                Sophistication With Modern Edge By Combining Gold And
                Contemporary Metals.
              </p>
              <Button variant="dark" onClick={()=> window.open("https://www.benchmarkrings.com/collections/ammara-stone" , "_blank")}>View Collection</Button>
            </Col>
          </Row>

          {/* ===== Brook & Branch ===== */}
          <Row className="align-items-center  flex-md-row-reverse">
            <Col md={6} className="text-md-right" >
             <div className="image-hover-wrapper">
              <img
                src={brook}
                alt="Brook & Branch"
                className="img-fluid rounded shadow"
                 onClick={()=> window.open("https://www.benchmarkrings.com/collections/brook-and-branch"    , "_blank")}
              />
             </div>
            </Col>

            <Col md={6} className="text-center text-md-start mt-4 mt-md-0 ">
              <h4 className="fw-bold">Brook & Branch Collection</h4>
              <p>
                Unique And Visually Stunning Styles Dedicated To All The Avid
                Outdoor Enthusiasts, Using Both Traditional And Contemporary
                Metals.
              </p>
              <Button variant="dark"  onClick={()=> window.open("https://www.benchmarkrings.com/collections/brook-and-branch"    , "_blank")}>View Collection</Button>
            </Col>
          </Row>

          {/* ===== Benchmark Collection ===== */}
          <Row className="align-items-center">
            <Col md={6}>
             <div className="image-hover-wrapper">
              <img
                src={benchmark}
                alt="Benchmark Collection"
                className="img-fluid rounded shadow"
                onClick={()=> window.open("https://www.benchmarkrings.com/collections/classics" , "_blank")}
              />
             </div>
            </Col>

            <Col md={6} className="text-center text-md-start mt-4 mt-md-0">
              <h4 className="fw-bold">Benchmark Collection</h4>
              <p>
                Benchmarks Default Collection Showcasing A Wide Range Of Styles
                For You To Choose From.
              </p>
              <Button variant="dark"  onClick={()=> window.open("https://www.benchmarkrings.com/collections/classics " , "_blank")}>View Collection</Button>
            </Col>
          </Row>

          {/* ===== View All Button ===== */}
          <div className="text-center mt-md-5">
            <Button variant="dark" size="lg"  onClick={()=> window.open(" https://www.benchmarkrings.com/wedding-rings" , "_blank")}>
              View All Benchmark Rings
            </Button>
          </div>
        </Container>
      </section>
    </div>
     
    </>
  );
};

export default BenchmarkPage;